import {Component} from '@angular/core';
import {RouteTranslations} from '../../../models/abstract/routeTranslations';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-student-progress-support-article',
    template: `
        <ng-container i18n="@@support.articles.studentProgress">
            <p>In the free tracking platform you can view all your students' progress at a glance. When you click through you can see in great detail how far each student has progressed in the course.</p>
            <h2>By class</h2>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>Click the name of a class.</span>
                </li>
                <li>
                    <div>
                        <h3>Student progress</h3>
                        <p>Open the <strong>Student Progress</strong> tab.</p>
                        <p>You will see a row of bars for each student. Each bar represents a chapter in the course. The bars turn green relative to completion of the chapter. This way you can see at a glance how far each student in the class has progressed in the course.</p>
                        <figure>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/classProgress.png" />
                            <figcaption>Move the mouse over a bar to see the progress for each lesson in that chapter.</figcaption>
                        </figure>
                        <p>Click on a student's name to see progress in more detail. You can also click on the bar of a chapter to see the student's results for that chapter.</p>

                        <h3>Activity log</h3>
                        <p>Open the <strong>Activity log</strong> tab.</p>
                        <p>You can view all exercises made by students of this class on this page. You may use the filters at the top to only display the results of specific exercises or students.</p>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/classActivityLog.png" />

                        <figure>
                            <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/activityLogDetail.png" />
                            <figcaption>Click on the eye icon to see the mistakes made.</figcaption>
                        </figure>
                    </div>
                </li>
            </ol>

            <h2>By student</h2>
            <p>Either from the <a routerLink="/organization/students">Students Overview</a> or from a class's student list, click on a student's name to open the details.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentProgress.png" />
                <figcaption>General progress and averages.</figcaption>
            </figure>
            <p>Below the general progress you can find three tabs:</p>

            <h3>Course progress</h3>
            <p>In this tab you can see a series of circles next to each lesson. Each circle represents an exercise. If the circle is colored green, the exercise has been completed.</p>
            <p><img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentCourseProgress.png" /></p>
            <p>You can click on each circle to see the results for just that exercise.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentExerciseAttempts.png" />
                <figcaption>You can click on the eye icon to see the mistakes made.</figcaption>
            </figure>

            <h3>Activity log</h3>
            <p>On this tab you can see a log of all exercises made by this student. At the top you may choose to only show the results of a specific exercise.</p>
            <p><img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentActivityLog.png" /></p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/activityLogDetail.png" />
                <figcaption>Click on the eye icon to see the mistakes made.</figcaption>
            </figure>

            <h3>Badges</h3>
            <p>On this tab you can see which badges the student has already earned. The student can also view these at any time on the <a routerLink="/{{ RouteTranslations.progress[languageService.getActiveLanguageCode()] }}">Progress</a> page.</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/studentBadges.png" />
            </figure>
        </ng-container>
    `
})
export class StudentProgressSupportArticleComponent {
    protected readonly RouteTranslations = RouteTranslations;

    constructor(
        public languageService: LanguageService
    ) {}
}
